const PayType = {
    0: '카드',
    1: '카드취소',
    2: '현금영수증',
    3: '현금영수증취소',
    4: '선불',
    5: '현금',
    6: 'QR패드신용',
    7: 'QR패드신용취소',
    8: 'QR패드선불',
    9: '지역화폐',
    10: '지역화폐취소',
    11: '자동결제',
    12: 'QR결제',
    13: 'QR결제취소',
    98: '타입오류',
    99: '총합계',
    1000: '-',
    2000: '자동결제 • 카카오',
    2001: '자동결제 • 우버',
    2002: '자동결제 • 코나',
};

export const PayTypeByNames = {
    CARD: 0,
    AUTOPAY: 11,
}

const invertedPayType = Object.keys(PayType).reduce((acc, key) => {
    acc[PayType[key]] = key;
    return acc;
}, {})

export function convertTransactionPayTypeToPayType(payMethod) {
    if (invertedPayType[payMethod]) {
        return invertedPayType[payMethod];
    }

    return payMethod;
}

export function convertPayTypeToTxt(typeId) {
    return PayType[typeId] || typeId;
}

export default PayType
